import { loginSlice } from "./loginSlice";

const { default: requests } = require("../../helpers/http");
const authEndpoint = "https://enigmatic-beach-93405.herokuapp.com/login";

const login = (data) => {
  return requests.post(authEndpoint, data);
};
export default login;
